import React from 'react';
import { useParams, Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getRuleById } from '../config/rules';
import { getCategoryById } from '../config/categories';
import ComingSoon from '../shared/ComingSoon';
import Member from './Member';
import Subhadra from './Subhadra';
import HouseholdRoster from './HouseholdRoster';
import GenderRoster from './GenderRoster';
import Indicators from './Indicators';
import Anganwadi from './Anganwadi';
import SchoolCount from './SchoolCount';
import SmallHouseholds from './SmallHouseholds';
import MultiSpouse from './MultiSpouse';
import AgeEducation from './AgeEducation';
import InstitutionalDelivery from './InstitutionalDelivery';
import HealthInsurance from './HealthInsurance';
import DuplicateMember from './DuplicateMember';

// Maps an enabled rule's `component` to its screen.
const COMPONENTS = { member: Member, subhadra: Subhadra, roster: HouseholdRoster, genderRoster: GenderRoster, indicators: Indicators, anganwadi: Anganwadi, schoolCount: SchoolCount, smallHouseholds: SmallHouseholds, multiSpouse: MultiSpouse, ageEducation: AgeEducation, institutionalDelivery: InstitutionalDelivery, healthInsurance: HealthInsurance, duplicateMember: DuplicateMember };

export default function RulePage() {
  const { id } = useParams();
  const rule = getRuleById(id);

  if (!rule) {
    return (
      <div className="page">
        <ComingSoon title="Unknown rule" description="This validation rule does not exist." />
      </div>
    );
  }

  if (!rule.enabled) {
    const category = getCategoryById(rule.category);
    return (
      <div className="page">
        {category ? (
          <Link to={`/category/${category.id}`} className="back-link">
            <ArrowBackIcon fontSize="small" /> Back to {category.label}
          </Link>
        ) : null}
        <ComingSoon
          title={rule.title}
          description="This validation rule is planned but not yet available. Its screen and data path are wired for a future release."
        />
      </div>
    );
  }

  const Comp = COMPONENTS[rule.component];
  return Comp ? <Comp rule={rule} /> : <ComingSoon title={rule.title} />;
}
